import { get } from '../api.service';

export interface InvoiceSearchParams {
  PageNumber: number;
  PageSize: number;
  searchQuery?: string;
  status?: number;
  type?: number;
}

export interface InvoiceSearchItem {
  id: number;
  invoiceNumber: string;
  clientName: string;
  amount: number;
  dueDate: string;
  invoiceStatus: number;
  stage?: string;
}

export interface InvoiceSearchResponse {
  statusCode: number;
  message: string;
  response: InvoiceSearchItem[];
  totalCount: number;
  numberOfPages: number;
}

/**
 * Fetches invoices with advanced search functionality
 * Endpoint: GET /api/invoicecontrollerv2/get-all-invoice-v2
 * @param params - Search parameters including PageNumber, PageSize, and searchQuery
 * @returns Promise with invoice search results
 */
export const fetchInvoiceSearchApi = async (
  params: InvoiceSearchParams
): Promise<InvoiceSearchResponse> => {
  try {
    const response = await get('/invoicev2/get-all-invoice-v2', {
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
      ...(params.searchQuery && { searchQuery: params.searchQuery }),
      ...(params.status !== undefined && params.status !== 0 && { status: params.status }),
      ...(params.type !== undefined && params.type !== 0 && { type: params.type }),
    });
    return response;
  } catch (error: any) {
    console.error('Invoice search API error:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Failed to fetch invoices'
    );
  }
};
